import { wasteDataT } from 'components/invoicing/invoice/Form/WasteData.vue';
import { BaseSchema, ModelType, type ToManyRelationship, type ToOneRelationship } from '~~/app/base/schemas/BaseSchema';

type InvoiceRelationships = {
    invoiceSections: ToManyRelationship<ModelType.INVOICE_SECTIONS>;
    contact: ToOneRelationship<ModelType.CONTACTS>;
    worksite: ToOneRelationship<ModelType.WORKSITES>;
    lead: ToOneRelationship<ModelType.LEADS>;
    wasteDataCollection: ToOneRelationship<ModelType.WASTE_DATAS>;
    worksiteProgressBilling: ToOneRelationship<ModelType.WORKSITE_PROGRESS_BILLINGS>;
    worksiteProgressBillings: ToManyRelationship<ModelType.WORKSITE_PROGRESS_BILLINGS>;
    einvoicingSendings: ToManyRelationship<ModelType.EINVOICING_SENDINGS>;
    currentEinvoicingSending: ToOneRelationship<ModelType.EINVOICING_SENDINGS>;
};

type InvoiceAttributes = {
    documentType: string;
    status: string;
    number: string | null;
    internalNumber: number | null;
    subtotal: number | null;
    totalTax: number | null;
    total: number | null;
    totalPaid: number | null;
    totalDue: number | null;
    pdfId: string | null;
    title: string | null;
    description: string | null;
    conditions: string | null;
    belgianStructuredCommunication: string;
    dueAt: string | null;
    sentAt: string | null;
    customCreatedAt: string | null;
    trueDate: string;
    archivedAt: string | null;
    contactState: Record<string, any> | null;
    energyAfterRenovation: string | null;
    inspectedAt: string | null;
    frenchVatCertificateUrl: string | null;
    wasteData: wasteDataT | null;
    purchaseOrder: string | null;
    buyerReference: string | null;
};

type InvoiceMeta = {
    permissions: {
        delete: boolean;
    };
    depositInvoicesPercentage?: number;
    worksiteProgressBillingsPercentage?: number;
    isEditable: boolean;
};

export default class InvoiceSchema extends BaseSchema<InvoiceAttributes, InvoiceMeta, InvoiceRelationships> {
    protected type: ModelType = ModelType.INVOICES;
}
